// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SubHeader_wrapper__Ch_Hb","content":"SubHeader_content__28AG0","btnBack":"SubHeader_btnBack__28lQy","line":"SubHeader_line__30ZfF"};